import { Box, Grid, Typography, Tooltip } from "@mui/material";
import React, { useState } from "react";

const MostSearched = ({
  mostsearched,
  setSearchTerm,
  searchTerm,
  setMost_searched_change,
}) => {
  const handleSetMostsearched = (term) => {
    setSearchTerm(term);
    setMost_searched_change(term);
  };

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={12}
      pl={12}
      sx={{
        order: { xs: 2, sm: 2, md: 2, lg: 5 },
        marginBottom: "10px",
          paddingLeft:"0px"
      }}
    >
      <Box
        sx={{
          background: "#c2ddd1",
          padding: "15px 20px",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            gap: "10px",
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              lineHeight: "20px",
              fontWeight: "600",
              color: "#474747",
            }}
          >
            Most Searched
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              gap: "10px",
              width: "100%",
              overflowX: "auto",
              scrollbarWidth: "thin",
              "&::-webkit-scrollbar": {
                height: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#F0F4FB",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#4ea27d",
                borderRadius: "3px",
              },
              paddingBottom: "6px",
            }}
          >
            {mostsearched.map((option, index) => (
              <Tooltip title={option.search_content} key={index} arrow>
                <Typography
                  onClick={() => handleSetMostsearched(option.search_content)}
                  sx={{
                    boxShadow: "1px 2px 4px #454040",
                    fontWeight: "400",
                    fontSize: "15px",
                    lineHeight: "16px",
                    color:
                      searchTerm === option.search_content
                        ? "#F0F4FB"
                        : "#474747",
                    padding: "8px",
                    background:
                      searchTerm === option.search_content
                        ? "#4ea27d"
                        : "#F0F4FB",
                    border: "2px solid #A7A7A7",
                    borderRadius: "8px",
                    textAlign: "center",
                    cursor: "pointer",
                    transition: "all 0.3s",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    "&:hover": {
                      background: "#4ea27d",
                      color: "#F0F4FB",
                    },
                  }}
                >
                  {option.search_content.length > 5
                    ? `${option.search_content.substring(0, 5)}...`
                    : option.search_content}
                </Typography>
              </Tooltip>
            ))}
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};
export default MostSearched;
